const useRelativeSize = ({
  width,
  height,
  maxWidth
}: {
  width: number;
  height: number;
  maxWidth: number | undefined;
}) => {
  if (maxWidth && width > maxWidth) {
    const widthRatio = width / maxWidth;
    return {
      width: maxWidth,
      height: height / widthRatio
    };
  }

  return {
    width,
    height
  };
};

export default useRelativeSize;
